import React, { Component } from "react";
import styled, { css } from "styled-components";
import MaskedInput from "react-maskedinput";
import "./TimeSelector.css";
import { TimeIconUp } from "../Icons";
import { TimeIconDown } from "../Icons";

const InputView = styled(MaskedInput)`
  direction: ltr !important;
  display: inline-block;
  vertical-align: top;
  width: 100%;
  min-height: 39px;
  color: #4e2a81;
  padding: 0 7px;
  margin: 0px;
  box-sizing: border-box;
  font-weight: 400;
  font-size: 16px;
  line-height: 1;
  font-family: Roboto, Arial, sans-serif;
  color: #4e2a81;
  background-color: #fff;
  border: 1px solid #cfcfcf;
  border-radius: 3px;
  box-shadow: inset 0px 2px 0px 0px rgba(227,227,227,1);
  :focus {
    outline: none;
  }
  @media (max-width: 480px) {
    min-height: 32px;
    font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "14px"};
  }
  
  ${props => props.invalid && css`
    border-color: #e85747;
    color: #e74c3c;
  `}
`;

export default class TimeSelector extends Component {
  /**
   * Parse string time into {h, m} object.
   * @param  {String} value String like 'HH:MM'.
   * @return {Object}       Object with h (hours ) and m (minutes) properties.
   */
  parseString = value => {
    const [hours, minutes] = (value || ":").split(":");
    return {
      hours,
      minutes
    };
  };

  /**
   * Add leading zero to value.
   * @param  {String} value
   * @return {String}
   */
  addZero = value => {
    if (value === undefined || value === "") return value;

    const value_ = +value;

    return value_ < 10 ? `0${value_}` : value_;
  };

  /**
   * Extract hours from props value.
   * @return {String}
   */
  getHours = () => {
    return this.parseString(this.props.value).hours;
  };

  /**
   * Extract minutes from props value.
   * @return {String}
   */
  getMinutes = () => {
    return this.parseString(this.props.value).minutes;
  };

  onChange = e => {
    this.props.onChange(e.target.value);
  };

  incValue = () => {
    const { hours, minutes } = this.parseString(this.props.value);
    let h = parseInt(hours, 10);
    let m = parseInt(minutes, 10);

    if (m < 59) {
      m += 1;
    } else {
      m = "00";
      if (h < 23) {
        h += 1;
      } else {
        h = "00";
      }
    }

    h = this.addZero(h);
    m = this.addZero(m);

    this.props.onChange(`${h}:${m}`);
  };

  decValue = () => {
    const { hours, minutes } = this.parseString(this.props.value);
    let h = parseInt(hours, 10);
    let m = parseInt(minutes, 10);

    if (m > 0) {
      m -= 1;
    } else {
      m = "59";
      if (h > 0) {
        h -= 1;
      } else {
        h = "23";
      }
    }

    h = this.addZero(h);
    m = this.addZero(m);

    this.props.onChange(`${h}:${m}`);
  };

  render() {
    const { value, invalid, onBlur, autoComplete } = this.props;

    return (
      <div className="TimeSelector">
        <InputView
          mask="11:11"
          name="time"
          placeholder=""
          onChange={this.onChange}
          value={value}
          invalid={invalid}
          onBlur={onBlur}
          autoComplete={autoComplete}
        />
        <TimeIconUp
          className="TimeSelector__icons TimeSelector__icons--up"
          onClick={this.incValue}
        />
        <TimeIconDown
          className="TimeSelector__icons TimeSelector__icons--down"
          onClick={this.decValue}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/OfflinePopup/TimeSelector.js